import { required } from "vuelidate/lib/validators";
import vuelidate from "vuelidate";
export default {
  detailVoucherFormCustom: {
    price_cut: {
      voucherForm: {
        voucher_code: { },
        voucher_group: { required },
        name: { required },
        abbreviation: { required },
        start_date: { required },
        end_date: {},
        voucher_type: { required },
        price: { required},
        percentage: {},
        status: { required },
        max_price: { required },
        description: { required },
        tnc: { required },
        min_transaction: { },
        payment:{},
        voucher_group:{required},
      },
    },
    percentage_cut: {
      voucherForm: {
        voucher_code: { },
        name: { required },
        voucher_group: { required },
        abbreviation: { required },
        start_date: { required },
        end_date: {},
        voucher_type: { required },
        price: {},
        percentage: { required },
        status: { required },
        max_price: { required },
        description: { required },
        tnc: { required },
        min_transaction: {},
        payment:{},
        voucher_group:{required},
      },
    },
  },

  detailRequestFreezerFormCustom: {
    accepted: {
      requestForm: {
        status: { required },
        freezer_code: { required },
        serial_number: { required },
      },
    },
    rejected: {
      requestForm: {
        status: { required },
        freezer_code: {  },
        serial_number: {  },
      },
    },
  },

  addVoucherFormCustom: {
    price_cut: {
      voucherForm: {
        voucher_code: { },
        voucher_group: { required },
        name: { required },
        abbreviation: { required },
        start_date: { required },
        end_date: {},
        voucher_type: { required },
        price: { required },
        percentage: {},
        max_price: { required },
        description: { required },
        tnc: { required },
        min_transaction: {},
        payment:{},
        voucher_group:{required},
      },
    },
    percentage_cut: {
      voucherForm: {
        voucher_code: { },
        voucher_group: { required },
        name: { required },
        abbreviation: { required },
        start_date: { required },
        end_date: {},
        voucher_type: { required },
        price: {},
        percentage: { required },
        max_price: { required },
        description: { required },
        tnc: { required },
        min_transaction: {},
        payment:{},
        voucher_group:{required},
      },
    },
  },  

};
